<template>
    <div class="page-container">
        <h2 class="ta-c">
            合格投资者承诺函
        </h2>
        <div class="content">
            <div>本投资人（下称“本人”）郑重承诺如下：</div>
            <div>一、本人具有相应合法的投资主体资格，不存在任何法律、行政法规、中国证券监督管理委员会发布的规范性文件及交易规则禁止或限制的情形。</div>
            <div>二、本人提供的所有证件、资料均真实、全面、有效、合法，并且保证本次投资资金来源合法。</div>
            <div>三、本人已充分了解符合以下任一条件均为合格投资者，并承诺本人是符合该规定的合格投资者。</div>
            <div>(一)本人为依法成立并存续的法人或者其他组织;</div>
            <div>(二)个人或家庭金融资产总计在其认购理财计划时超过50万元人民币，且能提供相关财产证明的自然人。</div>
            <div class="ta-r mt-30">本人：通过在线点击确认的方式签署</div>
        </div>
    </div>
</template>

<script>
    import { NavBar } from "vant";
    export default {
        name: "relief",
        components:{
            [NavBar.name]:NavBar
        },

        methods : {
            goPrev(){
                this.goableBack();
            }
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        line-height: 2;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 20px;
    }
    p {
        text-indent: 20px;
    }
    h3 {
        text-align: center;
    }
    .content > div >b:first-child {
        margin-right: 14px;
    }
    .van-nav-bar {
        background: #fff;

        .van-nav-bar__title {
            color: @dark;
        }
        .van-icon {
            color: @dark !important;
        }
    }
</style>